import { Actor, vec, Vector } from 'excalibur';
import { deathAnimation } from './animations';

export class DeathExplosion extends Actor {
  constructor(position: Vector) {
    super({
      pos: position,
      width: 80,
      height: 48,
      z: 1000,
      opacity: 1,
    });

    this.graphics.use(deathAnimation.clone());
    this.scale = vec(6, 6);

    setTimeout(() => {
      this.kill();
    }, 1000);
  }
}
